// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".summary-box{background-color:#f5f4fc}.lender-detail-dialog .el-dialog__footer{justify-content:center!important}.green-text{color:#00b849}.fontColorLenderMatch{color:#505050}.header-legend{padding:5px;background-color:#1570ef;color:#fff;border-radius:3px;position:relative;left:15px;top:10px}.card-border{border:1px solid #bdbdbd}.lender-detail-dialog .el-card.is-always-shadow{box-shadow:0 0 0 0 rgba(0,0,0,.1)!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
